import { render } from "./MoveFolder.vue?vue&type=template&id=f23ad3e8"
import script from "./MoveFolder.vue?vue&type=script&lang=js"
export * from "./MoveFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__